import React, { useState } from 'react';
import './Contacts.css';

const Contacts = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Данные формы:', formData);
    setIsSubmitted(true);
    setTimeout(() => setIsSubmitted(false), 5000);
    
    setFormData({
      name: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  };

  const contactInfo = [
    {
      icon: '📍',
      title: 'Адреса',
      details: ['м. Одесса'],
    //   description: 'Наші фірмові магазини'
    },
    {
      icon: '📞',
      title: 'Телефони',
      details: ['+380988141025', '+380666438285'],
    //   description: 'Щодня з 8:00 до 20:00'
    },
    {
      icon: '🕒',
      title: 'Графік роботи',
      details: ['Пн-Нд: 8:00 - 20:00', 'Без вихідних'],
    }
  ];

  return (
    <section className="contacts" id="contact">
      <div className="container">
        <div className="contacts-header">
          <h2 className="section-title">Контакти</h2>
          <p className="section-subtitle">
            Ми завжди раді допомогти вам та відповісти на всі ваші запитання
          </p>
        </div>

        <div className="contacts-content">
          <div className="contact-info-section">
            <h3>Зв'яжіться з нами</h3>
            <div className="contact-info-grid">
              {contactInfo.map((item, index) => (
                <div key={index} className="contact-info-card">
                  <div className="contact-icon">{item.icon}</div>
                  <h4>{item.title}</h4>
                  <div className="contact-details">
                    {item.details.map((detail, idx) => (
                      <p key={idx} className="contact-detail">{detail}</p>
                    ))}
                  </div>
                  <p className="contact-description">{item.description}</p>
                </div>
              ))}
            </div>
          </div>

          <div className="contacts-main">
            <div className="contact-form-section">
              <h3>Напишіть нам</h3>
              {isSubmitted && (
                <div className="success-message">
                  ✅ Дякуємо! Ваше повідомлення відправлено. Ми зв'яжемося з вами найближчим часом.
                </div>
              )}
              <form className="contact-form" onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Ім'я *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      placeholder="Ваше ім'я"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="email">Email *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      placeholder="your@email.com"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Телефон</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="+38 (___) ___ __ __"
                    />
                  </div>
                  <div className="form-group">
                    <label htmlFor="subject">Тема</label>
                    <select
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                    >
                      <option value="">Оберіть тему</option>
                      <option value="order">Запитання про замовлення</option>
                      <option value="product">Консультація по продукції</option>
                      <option value="cooperation">Співпраця</option>
                      <option value="complaint">Скарга</option>
                      <option value="other">Інше</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Повідомлення *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    rows="6"
                    placeholder="Опишіть ваше питання детально..."
                  ></textarea>
                </div>

                <button type="submit" className="submit-btn">
                  Відправити повідомлення
                </button>
              </form>
            </div>

            <div className="contact-map-section">
              <div className="map-container">
                <div className="map-placeholder">
                  <div className="map-content">
                    <h4>Ми знаходимось тут</h4>
                    <p>м. Одесса</p>
                    <div className="map-actions">
                      <button className="map-btn">Відкрити в Google Maps</button>
                      <button className="map-btn">Маршрут</button>
                    </div>
                  </div>
                </div>
              </div>

              <div className="social-section">
                <h4>Слідкуйте за нами</h4>
                <div className="social-links">
                  <a href="https://www.instagram.com/monxuan.ua?igsh=bjhkZDBpbnRpeTI3" className="social-link instagram">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="contacts-cta">
            <div className="cta-content">
              <p>Телефонуйте прямо зараз - ми готові допомогти вам</p>
              <div className="cta-phone">
                <a href="tel:+380988141025" className="phone-link">
                  Директор +380988141025
                </a><br />
                <a href="tel:+380666438285" className="phone-link">
                  Менеджер по продажам  +380666438285
                </a>
              </div>
              <p className="cta-note">Дзвінки безкоштовні по всій Україні</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contacts;